import { FC } from 'react';

import { useTheme } from 'styled-components';

import { useMediaQuery } from '~/common/hooks/use-media-query';
import { Typography } from '~/common/components/Typograph';
import { Modal } from '~/common/components/Modal';
import { Button } from '~/common/components/Button';

import { ModalContent } from './styles';

interface IUnauthorizedModalProps {
  open: string;
  afterLoginRedirectUrl?: string;
  close: () => void;
}
export const UnauthorizedModal: FC<IUnauthorizedModalProps> = ({
  open,
  afterLoginRedirectUrl,
  close,
}) => {
  const isMobile = useMediaQuery('(max-width: 750px)');
  const theme = useTheme();

  return (
    <Modal
      isOpen={!!open}
      onClose={close}
      id="unathorized-prompt-modal"
      height={isMobile ? '200px' : 'auto'}
      width="400px"
      title="Acesso restrito"
    >
      <ModalContent>
        <Typography.Label
          size="medium"
          color="neutral0"
          {...(isMobile && {
            style: {
              marginBottom: 'auto',
            },
          })}
        >
          {open}
        </Typography.Label>

        <Button
          text="Entrar"
          width="100%"
          backgroundColor={theme.primary}
          onClick={close}
          href={`/login${
            afterLoginRedirectUrl ? `?redirect=${afterLoginRedirectUrl}` : ''
          }`}
        />
      </ModalContent>
    </Modal>
  );
};
